import React, { useState, useEffect, useCallback, useRef } from 'react';
import { InboxSolid } from '../components/Icons/FlowbiteIcons';
import NotificacionesService from '../axios_services/notificaciones.service';
import { ButtonSearch } from '../components/Buttons/Buttons';
import NotificacionItem from '../components/Notificaciones/NotificacionItem';
import Loader from '../components/Loader/Loader';
import './Notificaciones.css';

const dispatchBadge = (count) => {
    window.dispatchEvent(new CustomEvent('mec-notif-update', { detail: { count } }));
};

const periodoActual = () => {
    const now = new Date();
    return `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}`;
};

function Notificaciones() {
    const initialFetch = useRef(false);

    const [periodo_fecha, setPeriodoFecha] = useState(periodoActual);
    const [noLeidas, setNoLeidas] = useState([]);
    const [leidas, setLeidas] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const todasNotificaciones = [...noLeidas, ...leidas].sort((a, b) => new Date(b.fecha) - new Date(a.fecha));

    const cargar = useCallback(async (periodo) => {
        setIsLoading(true);
        try {
            const notifData = await NotificacionesService.getNotificaciones(periodo);

            const pendientes = (notifData || [])
                .filter(n => Number(n.leida) === 0)
                .map(n => ({ source: 'stored', notificacion_id: n.notificacion_id, tipo_id: n.tipo_id, tipo_descripcion: n.tipo_descripcion, titulo: n.titulo, mensaje: n.mensaje, url_accion: n.url_accion, icono: n.icono, fecha: n.fecha_creacion }));

            const leidasStored = (notifData || [])
                .filter(n => Number(n.leida) === 1)
                .map(n => ({ source: 'stored', notificacion_id: n.notificacion_id, tipo_id: n.tipo_id, tipo_descripcion: n.tipo_descripcion, titulo: n.titulo, mensaje: n.mensaje, url_accion: n.url_accion, icono: n.icono, fecha: n.fecha_creacion }));

            setNoLeidas(pendientes);
            setLeidas(leidasStored);
            dispatchBadge(pendientes.length);
        } catch {
            setNoLeidas([]);
            setLeidas([]);
        } finally {
            setIsLoading(false);
        }
    }, []);

    useEffect(() => {
        if (!initialFetch.current) {
            cargar(periodoActual());
            initialFetch.current = true;
        }
    }, [cargar]);

    const handleBuscar = () => {
        cargar(periodo_fecha);
    };

    const marcarLeida = async (item) => {
        try {
            await NotificacionesService.marcarNotificacionLeida({ notificacion_id: item.notificacion_id });
        } catch { }
        const restantes = noLeidas.filter(x => x !== item);
        setNoLeidas(restantes);
        setLeidas(prev => [{ ...item }, ...prev]);
        dispatchBadge(restantes.length);
    };

    if (isLoading) return <Loader />;

    return (
        <div className="notificaciones-container">
            <h1>NOTIFICACIONES</h1>

            <div className="filtros">
                <div className="campo-fecha">
                    <label htmlFor="periodo_fecha">Periodo:</label>
                    <input
                        id="periodo_fecha"
                        type="month"
                        value={periodo_fecha}
                        onChange={(e) => setPeriodoFecha(e.target.value)}
                    />
                </div>
            </div>

            <ButtonSearch onClick={handleBuscar} isLoading={isLoading} />

            <div className="notificaciones-content" style={{ 
                marginTop: '2rem', 
                backgroundColor: '#f9fafb', 
                padding: '2rem', 
                borderRadius: '16px', 
                border: '1px dashed #d1d5db', 
                width: '100%',
                minHeight: '400px',
                maxHeight: 'calc(100vh - 280px)',
                overflowY: 'auto',
                boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.05), 0 2px 4px -1px rgba(0, 0, 0, 0.03)',
                display: 'flex',
                flexDirection: 'column'
            }}>
                {todasNotificaciones.length === 0 ? (
                    <div style={{ flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
                        <div style={{ backgroundColor: '#e5e7eb', borderRadius: '50%', padding: '1rem', display: 'inline-flex', marginBottom: '1.25rem' }}>
                            <InboxSolid size={56} className="notificaciones-empty-icon" style={{ color: '#6b7280' }} />
                        </div>
                        <p style={{ fontSize: '1.15rem', color: '#4b5563', margin: '0', fontWeight: '600' }}>Sin notificaciones</p>
                        <p style={{ fontSize: '0.95rem', color: '#9ca3af', marginTop: '0.5rem', marginBottom: '0' }}>No hay notificaciones en este periodo.</p>
                    </div>
                ) : (
                    <div className="notif-list" style={{ flex: 1 }}>
                        {todasNotificaciones.map((item, i) => (
                            <NotificacionItem
                                key={item.notificacion_id || i}
                                item={item}
                                esLeida={leidas.some(l => l.notificacion_id === item.notificacion_id)}
                                onMarcarLeida={marcarLeida}
                            />
                        ))}
                    </div>
                )}
            </div>
        </div>
    );
}

export default Notificaciones;